import { render, staticRenderFns } from "./InputPadHolder.vue?vue&type=template&id=7d294769&"
import script from "./InputPadHolder.vue?vue&type=script&lang=js&"
export * from "./InputPadHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports